import {NavigationEnd, Router} from "@angular/router";
import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ISpec} from "../../models/ISpec";
import {select} from "@angular-redux/store";
// import {edsEnvConfiguration} from "../../../environments/edsEnvConfiguration";
import {support_to_url, Utils} from "../../common/utils";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TranslateService} from '@ngx-translate/core';
import {ActionsService} from 'app/Redux/Actions/actions.service';
import {ApplicationToolbarActions} from 'app/Redux/Actions/application-toolbar-actions';
import {AnalyticsActions} from "../../Redux/Actions/analytics.actions";
import {Observable, Subscription} from "rxjs";
import {Ic} from "../../models/common";
import {edsTestEnabled, shareText, setWindowTitle} from "../../commonUtil";
import {getContextAndParamUrl} from "../../models/utils_specs";
import {ApplicationUserInfoActions} from "../../Redux/Actions/application-user-info-actions";

@Component({
  selector: 'edsng-header',
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./header.component.css', './header.component.mobile.css', './header.component.tablet.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  static catalogToContextMap = {
    ic_dcdc_catalogs: 'dcdc',
    ic_acdc_catalogs: 'acdc',
    ic_led_catalogs: 'led_dcdc',
    ic_led_acdc_catalogs: 'led_acdc',
    ic_acdc_catalogs_chargers: 'charger',
  };

  public searchContainerVisible: boolean = false;
  private _specs: ISpec<number> = null;
  private _catalog: string = null;
  private _appClass: string = null;
  private _selSolKey: string = null;
  _user = null;
  public showHeader: boolean = false;

  /**
   * Testo cercato nella barra di ricerca
   */
  textSearched: string = "";
  textSearchedHandle: Subscription;

  @select(['appSpec', 'spec', 'value']) specs$: Observable<ISpec<number>>;
  @select(['appCatalog', 'name']) catalog$: Observable<string>;
  @select(['appCatalog', 'appClass']) appClass$: Observable<string>;
  // @select(['appUserInfo', 'user']) user$;
  @select(['appToolBar', 'search']) searchField$;
  @select(['appCatalog', 'selectedSolution']) selectedSolution$: Observable<Ic>;

  constructor(public dialog: MatDialog, private router: Router, private act: ActionsService, private snack: MatSnackBar, public translate: TranslateService) {

  // router.events.subscribe((val) => {
  //   if(val instanceof  NavigationEnd){
  //     if(val.url = '/hackathon'){
  //       this.showHeader = false;
  //     } else {
  //       this.showHeader = true;
  //     }
  //     console.log(val.url);
  //   }
  // })
  //   this.showHeader = !window.location.hash.includes("hackathon");
  }

  ngOnInit() {
    this.textSearchedHandle = this.searchField$.subscribe(x => {
      // console.log('Search header ', x)
      if (x !== this.textSearched) {
        this.textSearched = x;
      }
      if (x !== '') {
        this.searchContainerVisible = true;
      }
    });

    this.specs$.subscribe(x => this._specs = x);
    this.catalog$.subscribe(x => this._catalog = x);
    this.appClass$.subscribe(x => this._appClass = x);
    // this.user$.subscribe(x => this._user = x);
    this.selectedSolution$.subscribe(x => this._selSolKey = x ? x.key : null);
    this.translate.onLangChange
      .subscribe(() => {
        setWindowTitle(this._appClass, this.translate);
      });

    this.showHeader = !window.location.hash.includes("hackathon");
  }


  isSearchVisible(): boolean {
    // this condition to check if the search icon in header will be visible only
    // when catalog is load and no solution is selected.
    return this._selSolKey == null && this._catalog !== '' && this._appClass !== '';
  }

  ngOnDestroy() {
    if (this.textSearchedHandle) {
      this.textSearchedHandle.unsubscribe();
    }
  }

  shareURL() {
    const contextToLoad = Utils.getFieldValue(HeaderComponent.catalogToContextMap, this._catalog);
    let url = document.location.href;
    if (contextToLoad) {
      const paramStr = getContextAndParamUrl(contextToLoad, this._specs, this.textSearched, this._selSolKey);
      url = document.location.href.replace(/#.*$/, "") + "#/widget/param?" + paramStr;
    }

    shareText(url, this.snack);
  }

  // loginUser() {
  //   this.act.sendAction(AnalyticsActions.sendAnalyticsEvent('login', 'engagement', {details: 'login header'}));
  //   this.act.sendAction(ApplicationUserInfoActions.loginUser());
  // }s

  manageSearchInput() {
    this.searchContainerVisible = !this.searchContainerVisible;
  }

  acceptOnlyCharNumber(evt) {
    return (/[a-z_\-\.\d]/i.test(evt.key));
  }

  liveSearch(evt) {
    /**
     * Viene aggiornato il testo cercato
     */
    setTimeout(() => {
      this.textSearched = evt.target.value;
      this.act.sendAction(ApplicationToolbarActions.setSearch(evt.target.value));
    }, 1);
  }

  /**
   * Funzione che viene richiamata per ripulire la searchBar
   */
  clear() {
    this.manageSearchInput();
    this.textSearched = "";
    this.act.sendAction(ApplicationToolbarActions.setSearch(this.textSearched));
  }

  // logoutUser() {
  //   this.act.sendAction(AnalyticsActions.sendAnalyticsEvent('login', 'engagement', {details: 'logout header'}));
  //   window.open(edsEnvConfiguration.logout + "?service=" + document.location.href, '_self');
  // }

  showPage(pageId: string) {
    this.act.sendAction(AnalyticsActions.sendAnalyticsEvent('support_request', pageId, {details: pageId}));
    window.open(support_to_url(pageId, this.translate.currentLang), '_blank');
  }

  setLanguage(lang: string) {
    this.act.sendAction(AnalyticsActions.sendAnalyticsEvent('change_language', 'project', {details: lang}));
    this.translate.use(lang);
    sessionStorage.setItem('user_lang', lang);
  }

  testEnabled() {
    return edsTestEnabled();
  }

  showHome() {
    this.router.navigate(["/"]);
  }
}
